var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-starter btn",class:{'btn-primary': !_vm.disabled},on:{"click":_vm.clicked}},[_c('div',{staticClass:"place inter-medium-white-16px"},[_vm._v("START")])])
}
var staticRenderFns = []

export { render, staticRenderFns }